export default __webpack_public_path__ + "static/media/p06 p02.233d56ee.jpg";